export const apiurl = "https://vasanthamhypermart.in/vasantham/api/";
export const ImageUrl =
  "https://vasanthamhypermart.in/vasantham/assets/images/";
export const FestivalUrl =
  "https://vasanthamhypermart.in/vasantham/assets/festivalimage/";
